import LocalizationBase from './base';

export default class GestureIns extends LocalizationBase {
    constructor() {
        super();
        this.mType = 'gestureIns';
    }
}